import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { SectionHeading } from '../SectionHeading';
import { faqs } from '../../data/faqs';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-mist px-5 py-16 sm:py-20" aria-label="Frequently asked questions" data-id="element-147" data-mp="1235324nxj2vp">
      <div className="mx-auto max-w-3xl" data-id="element-148" data-mp="1pspoqvbgwe8o">
        <SectionHeading title="Frequently asked questions" data-id="element-149" data-mp="1uraoktmt4vwl" />

        <div className="mt-10 space-y-3" data-id="element-150" data-mp="1uqivbpgona9h">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.question} className="overflow-hidden rounded-2xl bg-white" data-id="element-151" data-mp="1l17ok9h9qhor" data-mpi={i}>
                <h3 data-id="element-152" data-mp="28r208npuq07f">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left font-display text-base font-extrabold leading-snug text-navy-950 focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-electric" data-id="element-153" data-mp="28qjun0hau9mu">
                    {faq.question}
                    <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-[transform,background-color] duration-200 ease-out ${isOpen ? 'rotate-45 bg-electric text-white' : 'bg-mist text-navy-900'}`} data-id="element-154" data-mp="2to0o1se2qjl6">
                      <PlusIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-155" data-mp="3cftebf1rdqp7" />
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-156" data-mp="1n1esb2i4khxe">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-157" data-mp="1i33kexbe4hht">
                      <p className="px-5 pb-5 text-[15px] leading-relaxed text-ink/75" data-id="element-158" data-mp="2lpffhuum1b6g">{faq.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <div className="mt-10" data-id="element-159" data-mp="2up2g4efimcyg">
          <CtaButton label="All clear — I want my access" data-id="element-160" data-mp="2uo0u5ewyo61y" />
        </div>
      </div>
    </section>;
}